import type { PostContentObjectDetail, PostContentObjectList } from 'models';
import { Flex, ReadMore } from 'ui';
import { PostRendererBody } from './post-renderer-body';
import { SharedContentObject } from './shared-content-object';

type P = {
  item: PostContentObjectDetail | PostContentObjectList;
  showReadMore?: boolean;
};

const PostContentObjectBody = ({ item, showReadMore }: P) => (
  <Flex gap="ms" vertical>
    {showReadMore ? (
      <ReadMore>
        <PostRendererBody item={item} />
      </ReadMore>
    ) : (
      <PostRendererBody item={item} />
    )}
    {item.sharedContentObjectId ? <SharedContentObject id={item.sharedContentObjectId} /> : null}
  </Flex>
);

export default PostContentObjectBody;
